import {ChangeDetectionStrategy, Component, EventEmitter, inject, Output} from '@angular/core';
import {ReactiveFormsModule, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {PatronActions} from '@store/patron/patron.actions';
import {ExtendedFormBuilder} from '@aviary/forms/extensions/extended-form-builder/extended-form-builder';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {MatCard, MatCardContent} from '@angular/material/card';
import {InputFormFieldComponent} from '@aviary/forms/fields/input-form-field/input-form-field.component';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';
import {TextButtonComponent} from '@aviary/buttons/text-button/text-button.component';

@Component({
  selector: 'px-forgot-password',
  template: `
    <mat-card>
      <mat-card-content class="px-5">
        <form [formGroup]="formGroup" class="w-full flex flex-col gap-y-4 items-center">
          <mx-input-form-field fieldName="email" [externalLabel]="true" [uppercaseExternalLabel]="false" placeholder="example@domainname.com"
                               [includeClearButton]="false" [formGroup]="formGroup" overrideLabel="Email Address" class="w-full no-bottom-margin"/>

          <mx-filled-button label="Reset Password" [enabled]="formGroup.valid" (click)="resetPatronPassword()" class="w-full"/>

          <mx-text-button startIcon="arrow_back" label="Back to Login" (click)="backToLogin()"/>
        </form>
      </mat-card-content>
    </mat-card>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCard, MatCardContent, InputFormFieldComponent, ReactiveFormsModule, FilledButtonComponent, TextButtonComponent]
})
export class ForgotPasswordComponent {
  @Output() public readonly goBackToLogin: EventEmitter<never> = new EventEmitter<never>();
  private readonly store: Store = inject(Store);
  public readonly formGroup: ExtendedFormGroup = inject(ExtendedFormBuilder).nonNullable.extendedGroup({
    email: ['', {validators: [Validators.required, Validators.email]}]
  });

  resetPatronPassword(): void {
    this.store.dispatch(PatronActions.resetPatronPassword(this.formGroup.value.email));
  }

  backToLogin(): void {
    this.goBackToLogin.emit();
  }
}
